import api from '../../api'

export default {

    namespaced: true,



    state: {
        user: true,
        authorized: true,
    },

    getters: {},

    mutations: {

        SET_USER(state, user) {
            state.user = user
        },

        SET_AUTHORIZED(state, value) {
            state.authorized = value
        }

    },

    actions: {
        AUTH({commit, dispatch}, token) {

           return api.authUser(token)
                .then(user => {


                    commit("SET_AUTHORIZED", true)
                    commit("SET_USER", user)

                  

                    return dispatch('settings/FETCH', null, { root: true })
                })
                .catch( error => {
                    commit("SET_AUTHORIZED", false)
                    commit("SET_USER", null)
                    return error
                })

        }
    }
}